import axios from "axios";

class UploadFile {
  upload(endpoint, obj) {
    let formData = new FormData();
    Object.keys(obj).forEach(el=>{
      formData.append(`${el}`, obj[el]);
    });
    const token = localStorage.getItem("shipping-admin-token");
    return axios.post(`${process.env.VUE_APP_BASE_URL}${endpoint}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization":"Bearer ".concat(token),
      },
    });
  }
}

export default new UploadFile();
